export default __webpack_public_path__ + "static/media/banner.d3395c8f.png";